module.exports = __webpack_public_path__ + "img/cg_oldtown_grab.8a489bb8.jpg";